/**
 * @generated SignedSource<<772a512ea23d207159cd5f1093f10195>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateCouponInput = {
  active?: boolean | null | undefined;
  assignmentOnly?: boolean | null | undefined;
  code?: string | null | undefined;
  discount?: number | null | undefined;
  discountType?: string | null | undefined;
  duration?: number | null | undefined;
  name: string;
  organizationId?: string | null | undefined;
  systemOldId?: string | null | undefined;
  uses?: number | null | undefined;
  validDays?: number | null | undefined;
  validFrom?: any | null | undefined;
  validTimeEnd?: number | null | undefined;
  validTimeStart?: number | null | undefined;
  validUntil?: any | null | undefined;
};
export type useCouponMutationsCreateMutation$variables = {
  input: CreateCouponInput;
};
export type useCouponMutationsCreateMutation$data = {
  readonly createCoupon: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
      readonly vars: any | null | undefined;
    }>;
    readonly result: {
      readonly active: boolean | null | undefined;
      readonly assignmentOnly: boolean;
      readonly code: string | null | undefined;
      readonly created: any | null | undefined;
      readonly discount: number | null | undefined;
      readonly discountType: string | null | undefined;
      readonly duration: number | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly oldId: string | null | undefined;
      readonly organizationId: string | null | undefined;
      readonly systemId: string | null | undefined;
      readonly systemOldId: string | null | undefined;
      readonly uses: number | null | undefined;
      readonly validDays: number | null | undefined;
      readonly validFrom: any | null | undefined;
      readonly validTimeEnd: number | null | undefined;
      readonly validTimeStart: number | null | undefined;
      readonly validUntil: any | null | undefined;
    } | null | undefined;
  };
};
export type useCouponMutationsCreateMutation = {
  response: useCouponMutationsCreateMutation$data;
  variables: useCouponMutationsCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCouponResult",
    "kind": "LinkedField",
    "name": "createCoupon",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Coupon",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uses",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "systemId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "systemOldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignmentOnly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validTimeStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validTimeEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validFrom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validUntil",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vars",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCouponMutationsCreateMutation",
    "selections": (v2/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCouponMutationsCreateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "18e7555272e6af76a48da358c965200f",
    "id": null,
    "metadata": {},
    "name": "useCouponMutationsCreateMutation",
    "operationKind": "mutation",
    "text": "mutation useCouponMutationsCreateMutation(\n  $input: CreateCouponInput!\n) {\n  createCoupon(input: $input) {\n    result {\n      id\n      oldId\n      name\n      code\n      active\n      discount\n      discountType\n      duration\n      uses\n      systemId\n      systemOldId\n      organizationId\n      assignmentOnly\n      validDays\n      validTimeStart\n      validTimeEnd\n      validFrom\n      validUntil\n      created\n    }\n    errors {\n      message\n      fields\n      code\n      shortMessage\n      vars\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "837640c0c952760dd9ca33df41c22b0e";

export default node;
